const analyticsEn = {
  "nav.reports": "Reports",
  "nav.live_view": "Live view",
  "an.title": "Analytics",
  "an.reports": "Reports",
  "an.live": "Live view",
  "an.range": "Date range",
  "an.from": "From",
  "an.to": "To",
  "an.preset.today": "Today",
  "an.preset.yesterday": "Yesterday",
  "an.preset.last_7_days": "Last 7 days",
  "an.preset.last_30_days": "Last 30 days",
  "an.preset.last_90_days": "Last 90 days",
  "an.preset.this_month": "This month",
  "an.preset.last_month": "Last month",
  "an.preset.this_year": "This year",
  "an.preset.custom": "Custom",
  "an.compared": "Compared with {from} – {to}",
  "an.metric.total_sales": "Total sales",
  "an.metric.orders": "Orders",
  "an.metric.average_order_value": "Average order value",
  "an.metric.sessions": "Sessions",
  "an.metric.conversion_rate": "Conversion rate",
  "an.metric.returning_customer_rate": "Returning customer rate",
  "an.metric.net_sales": "Net sales",
  "an.metric.returns": "Returns",
  "an.sales_over_time": "Total sales over time",
  "an.this_period": "This period",
  "an.previous_period": "Previous period",
  "an.funnel": "Conversion funnel",
  "an.funnel_hint": "Sessions that went on to each step.",
  "an.funnel.sessions": "Sessions",
  "an.funnel.added_to_cart": "Added to cart",
  "an.funnel.reached_checkout": "Reached checkout",
  "an.funnel.converted": "Ordered",
  "an.top_products": "Top products by net sales",
  "an.by_channel": "Sessions by channel",
  "an.by_device": "Sessions by device",
  "an.by_country": "Sessions by country",
  "an.by_referrer": "Top referrers",
  "an.landing_pages": "Top landing pages",
  "an.top_searches": "Top searches",
  "an.marketing": "Sales from campaigns (UTM)",
  "an.no_data": "No data for this period yet.",
  "an.no_campaigns": "No orders from tagged campaign links yet.",
  "an.channel.direct": "Direct",
  "an.channel.organic_search": "Search engines",
  "an.channel.paid_search": "Paid search",
  "an.channel.social": "Social",
  "an.channel.paid_social": "Paid social",
  "an.channel.email": "Email",
  "an.channel.whatsapp": "WhatsApp",
  "an.channel.sms": "SMS",
  "an.channel.referral": "Other websites",
  "an.channel.draft": "Draft orders",
  "an.channel.api": "API",
  "an.channel.pos": "Point of sale",
  "an.device.mobile": "Mobile",
  "an.device.desktop": "Desktop",
  "an.device.tablet": "Tablet",
  "an.device.other": "Other",
  "an.speed": "Online store speed",
  "an.speed_hint": "How fast real shoppers see your pages (75th percentile).",
  "an.speed_none": "Not enough visits yet to measure speed.",
  "an.speed_good": "Fast",
  "an.speed_ok": "Needs improvement",
  "an.speed_poor": "Slow",
  "an.speed_samples": "From {n} page loads",
  "an.search_reports": "Search reports",
  "an.category.sales": "Sales",
  "an.category.finance": "Finance",
  "an.category.orders": "Orders and fulfillment",
  "an.category.customers": "Customers",
  "an.category.inventory": "Inventory",
  "an.category.behavior": "Behavior",
  "an.category.marketing": "Marketing",
  "an.group_by": "Group by",
  "an.group.day": "Day",
  "an.group.week": "Week",
  "an.group.month": "Month",
  "an.group.quarter": "Quarter",
  "an.group.year": "Year",
  "an.total": "Total",
  "an.money_note": "Amounts in {currency}.",
  "an.schedule": "Schedule",
  "an.schedule_title": "Email this report",
  "an.scheduled": "The report will be emailed.",
  "an.frequency": "How often",
  "an.frequency.daily": "Every day",
  "an.frequency.weekly": "Every Monday",
  "an.frequency.monthly": "On the 1st of the month",
  "an.period": "Covering",
  "an.recipients": "Send to",
  "an.recipients_hint": "Email addresses, separated by commas. Up to 10.",
  "an.live_hint": "Shoppers on your store in the last 10 minutes.",
  "an.live.visitors": "Visitors right now",
  "an.live.carts": "Active carts",
  "an.live.checkout": "Checking out",
  "an.live.purchased": "Purchased",
  "an.live.today": "Today so far",
  "an.live.vs_yesterday": "Compared with yesterday at this time.",
  "an.live.locations": "Where they are",
  "an.live.nobody": "Nobody on the store right now.",
  "an.live.updated": "Updated {at}",
  "ce.title": "Customer events",
  "ce.nav_hint": "Pixels, server-side conversions and the cookie banner",
  "ce.description": "Measure your ads without pasting scripts: add your pixel ids, and purchases are also sent server-side so ad blockers don't hide them.",
  "ce.banner": "Cookie banner",
  "ce.banner_hint": "Analytics and marketing cookies wait for consent where a banner is shown.",
  "ce.banner.regions": "Where required by law",
  "ce.banner.regions_hint": "Shown to visitors in the EU, UK and Switzerland. Others aren't asked.",
  "ce.banner.always": "Always",
  "ce.banner.always_hint": "Every visitor chooses before analytics or marketing cookies are set.",
  "ce.banner.never": "Never",
  "ce.banner.never_hint": "No banner. Make sure your privacy policy covers this.",
  "ce.pixels": "Pixels",
  "ce.pixels_hint": "Connect by id. Pixels load after consent where a banner applies.",
  "ce.on": "On",
  "ce.off": "Off",
  "ce.server_side": "Server-side purchases",
  "ce.sent": "{n} purchases sent in the last 30 days",
  "ce.edit": "Edit",
  "ce.connect": "Connect",
  "ce.enabled": "Turned on",
  "ce.docs": "Where to find these",
  "ce.keep_secret": "Saved. Leave empty to keep it.",
  "ce.server_hint": "Optional. Sends purchases server-side too (deduplicated with the browser pixel).",
  "ce.provider.ga4": "Google Analytics 4",
  "ce.provider.ga4_hint": "Traffic and ecommerce events in Google Analytics.",
  "ce.provider.ga4_steps": "In Google Analytics open Admin › Data streams › your web stream. Copy the Measurement ID (G-…). For server-side purchases create a Measurement Protocol API secret on the same page.",
  "ce.provider.google_ads": "Google Ads",
  "ce.provider.google_ads_hint": "Purchase conversions for your Google Ads campaigns.",
  "ce.provider.google_ads_steps": "In Google Ads open Goals › Conversions, create a website purchase conversion, choose to set it up manually and copy the conversion ID (AW-…) and label.",
  "ce.provider.meta": "Meta (Facebook and Instagram)",
  "ce.provider.meta_hint": "Meta Pixel and the Conversions API.",
  "ce.provider.meta_steps": "In Meta Events Manager select your dataset (pixel) and copy its ID. Under Settings › Conversions API generate an access token for server-side purchases.",
  "ce.provider.tiktok": "TikTok",
  "ce.provider.tiktok_hint": "TikTok Pixel and the Events API.",
  "ce.provider.tiktok_steps": "In TikTok Ads Manager open Assets › Events › Web events, choose your pixel and copy its ID. Generate an Events API access token in its settings.",
  "ce.provider.snapchat": "Snapchat",
  "ce.provider.snapchat_hint": "Snap Pixel and the Conversions API (popular in the Gulf).",
  "ce.provider.snapchat_steps": "In Snapchat Ads Manager open Events Manager, copy your Snap Pixel ID, and create a Conversions API token.",
  "ce.field.measurement_id": "Measurement ID",
  "ce.field.api_secret": "Measurement Protocol API secret",
  "ce.field.conversion_id": "Conversion ID",
  "ce.field.conversion_label": "Conversion label",
  "ce.field.pixel_id": "Pixel ID",
  "ce.field.test_event_code": "Test event code",
  "ce.field.access_token": "Access token",
  "ce.custom": "Custom pixels",
  "ce.custom_hint": "Your own tracking code. It runs in a sandbox: it receives the standard events but can't read or change your store's pages.",
  "ce.add_pixel": "Add custom pixel",
  "ce.no_pixels": "No custom pixels.",
  "ce.pixel_name": "Name",
  "ce.code": "Code",
  "ce.code_hint": "Use analytics.subscribe('event_name', (event) => { … }). Events: page_viewed, product_viewed, collection_viewed, search_submitted, product_added_to_cart, checkout_started, checkout_completed, all_events.",
  "ce.delete_pixel": "Delete this pixel?",
  "ce.delete_pixel_body": "It stops running on your store.",
  "an.report.sales_over_time": "Sales over time",
  "an.report.sales_by_product": "Sales by product",
  "an.report.sales_by_variant": "Sales by variant",
  "an.report.sales_by_vendor": "Sales by vendor",
  "an.report.sales_by_type": "Sales by product type",
  "an.report.sales_by_collection": "Sales by collection",
  "an.report.sales_by_discount": "Sales by discount code",
  "an.report.sales_by_channel": "Sales by channel",
  "an.report.sales_by_customer": "Sales by customer",
  "an.report.sales_by_location": "Sales by location",
  "an.report.sales_by_staff": "Sales by staff (draft orders)",
  "an.report.sales_by_gateway": "Sales by payment method",
  "an.report.finance_summary": "Finance summary",
  "an.report.payments_by_gateway": "Payments by method",
  "an.report.taxes": "Taxes (VAT)",
  "an.report.cod_reconciliation": "Cash on delivery reconciliation",
  "an.report.gross_profit": "Gross profit by product",
  "an.report.orders_over_time": "Orders over time",
  "an.report.fulfillment_time": "Time to fulfil and deliver",
  "an.report.delivery_performance": "Delivery performance by courier",
  "an.report.shipping_labels": "Shipping labels",
  "an.report.returns_by_product": "Returns by product",
  "an.report.returns_by_reason": "Return requests by reason",
  "an.report.cod_refusals": "Cash on delivery refusals",
  "an.report.new_vs_returning": "New and returning customers",
  "an.report.customer_cohorts": "Customer cohorts (monthly)",
  "an.report.customers_by_location": "Customers by location",
  "an.report.customer_lifetime": "Customer lifetime value",
  "an.report.one_time_customers": "One-time customers",
  "an.report.at_risk_customers": "Customers at risk",
  "an.report.stock_on_hand": "Stock on hand",
  "an.report.sell_through": "Sell-through rate",
  "an.report.abc_analysis": "ABC analysis",
  "an.report.inventory_valuation": "Inventory value",
  "an.report.low_stock": "Low stock",
  "an.report.conversion_over_time": "Conversion over time",
  "an.report.sessions_by_channel": "Sessions by channel",
  "an.report.sessions_by_referrer": "Sessions by referrer",
  "an.report.sessions_by_utm": "Sessions by campaign (UTM)",
  "an.report.sessions_by_device": "Sessions by device",
  "an.report.sessions_by_location": "Sessions by location",
  "an.report.landing_pages": "Landing pages",
  "an.report.top_searches": "Top searches",
  "an.report.zero_result_searches": "Searches with no results",
  "an.report.product_views": "Product views and purchases",
  "an.report.cart_abandonment": "Checkout abandonment",
  "an.report.web_vitals": "Page speed (web vitals)",
  "an.report.discount_performance": "Discount performance",
  "an.report.marketing_attribution": "Marketing attribution",
  "an.col.abandoned": "Abandoned",
  "an.col.abandonment_rate": "Abandonment rate",
  "an.col.added_to_cart": "Added to cart",
  "an.col.available": "Available",
  "an.col.average_order_value": "Average order value",
  "an.col.avg_days_to_deliver": "Days to deliver",
  "an.col.avg_hours_to_fulfil": "Hours to fulfil",
  "an.col.cancelled": "Cancelled",
  "an.col.checkouts": "Checkouts",
  "an.col.clicks": "Clicks",
  "an.col.cls": "CLS",
  "an.col.cod_amount": "COD amount",
  "an.col.cod_orders": "COD orders",
  "an.col.cod_outstanding": "COD to collect",
  "an.col.cohort": "Cohort",
  "an.col.collected": "Collected",
  "an.col.collection": "Collection",
  "an.col.committed": "Committed",
  "an.col.completed": "Completed",
  "an.col.conversion_rate": "Conversion rate",
  "an.col.converted": "Ordered",
  "an.col.cost": "Cost",
  "an.col.courier": "Courier",
  "an.col.cumulative_share": "Cumulative share",
  "an.col.customer": "Customer",
  "an.col.customers": "Customers",
  "an.col.days_of_inventory": "Days of inventory",
  "an.col.declined": "Declined",
  "an.col.delivered": "Delivered",
  "an.col.delivered_rate": "Delivered rate",
  "an.col.discount": "Discount",
  "an.col.discount_amount": "Discount amount",
  "an.col.discount_code": "Discount code",
  "an.col.discounts": "Discounts",
  "an.col.email": "Email",
  "an.col.failed": "Failed",
  "an.col.first_order": "First order",
  "an.col.fulfilled_orders": "Fulfilled orders",
  "an.col.gift_card_sales": "Gift card sales",
  "an.col.grade": "Grade",
  "an.col.gross_profit": "Gross profit",
  "an.col.gross_sales": "Gross sales",
  "an.col.incoming": "Incoming",
  "an.col.inp_ms": "INP (ms)",
  "an.col.labels": "Labels",
  "an.col.last_order": "Last order",
  "an.col.lcp_ms": "LCP (ms)",
  "an.col.location": "Location",
  "an.col.margin": "Margin",
  "an.col.month_1": "Month 1",
  "an.col.month_12": "Month 12",
  "an.col.month_2": "Month 2",
  "an.col.month_3": "Month 3",
  "an.col.month_6": "Month 6",
  "an.col.net_sales": "Net sales",
  "an.col.new_customers": "New customers",
  "an.col.new_customer_sales": "New customer sales",
  "an.col.on_hand": "On hand",
  "an.col.order_date": "Order date",
  "an.col.orders": "Orders",
  "an.col.outstanding": "Outstanding",
  "an.col.page_type": "Page type",
  "an.col.payment_method": "Payment method",
  "an.col.period": "Period",
  "an.col.product": "Product",
  "an.col.rate": "Rate (%)",
  "an.col.reached_checkout": "Reached checkout",
  "an.col.reason": "Reason",
  "an.col.received": "Received",
  "an.col.recovered": "Recovered",
  "an.col.refunded": "Refunded",
  "an.col.refusal_rate": "Refusal rate",
  "an.col.requests": "Requests",
  "an.col.results": "Results",
  "an.col.returning_customers": "Returning customers",
  "an.col.returning_customer_sales": "Returning customer sales",
  "an.col.return_rate": "Return rate",
  "an.col.returns": "Returns",
  "an.col.samples": "Page loads",
  "an.col.search": "Search",
  "an.col.searches": "Searches",
  "an.col.sell_through": "Sell-through",
  "an.col.service": "Service",
  "an.col.sessions": "Sessions",
  "an.col.share": "Share",
  "an.col.shipments": "Shipments",
  "an.col.shipping": "Shipping",
  "an.col.sku": "SKU",
  "an.col.source_medium_campaign": "Source / medium / campaign",
  "an.col.tax": "Tax",
  "an.col.tax_collected": "Tax collected",
  "an.col.taxes": "Taxes",
  "an.col.threshold": "Low stock at",
  "an.col.total_sales": "Total sales",
  "an.col.total_spent": "Total spent",
  "an.col.ttfb_ms": "TTFB (ms)",
  "an.col.unit_cost": "Unit cost",
  "an.col.units": "Units",
  "an.col.units_per_order": "Units per order",
  "an.col.units_returned": "Units returned",
  "an.col.units_sold": "Units sold",
  "an.col.uses": "Uses",
  "an.col.value": "Value",
  "an.col.variant": "Variant",
  "an.col.views": "Views",
  "an.col.view_to_order": "View to order",
  "an.col.visitors": "Visitors",
  "an.col.weight_kg": "Weight (kg)",
  "an.col.channel": "Channel",
  "an.col.device": "Device",
  "an.col.landing_page": "Landing page",
  "an.col.product_type": "Product type",
  "an.col.referrer": "Referrer",
  "an.col.staff": "Staff",
  "an.col.utm": "Campaign (UTM)",
  "an.col.vendor": "Vendor",
} as const;

export default analyticsEn;
